<div class="pdf-container" style="width:100%; height:100%; overflow:hidden;">
	<!-- Header Controls -->
	<div class="navbar navbar-default">
	  <div class="container-fluid">
		    <div class="btn-group" ngbDropdown>
		        <button id="pdf-menu-button" type="button" class="btn btn-primary btn-sm navbar-btn" ngbDropdownToggle title="{{LOCALIZATION.pdfViewMode}}" [attr.aria-label]="LOCALIZATION.pdfViewMode">
		            {{pdf.viewMode}} <span class="caret"></span>
		        </button>
		        <ul class="dropdown-menu pointMe" ngbDropdownMenu aria-labelledby="pdf-menu-button" role="menu">
		            <li><a (click)='togglePdfPageMode("Full")' [ngClass]="{'active' : !pdf.isSinglePageMode()}">{{LOCALIZATION.full}}</a></li>
		            <li><a (click)='togglePdfPageMode("Single")' [ngClass]="{'active' : pdf.isSinglePageMode()}">{{LOCALIZATION.single}}</a></li>
		            <li *ngIf="userPermissions['ROLE_ANNOTATION_EDITOR'] && package.pages.length === 0" class="hidden-xs">
		                <a (click)='openAnnotationEditor()' [ngClass]="{'active' : false}">
		                    {{LOCALIZATION.annotations}} <i class="fa fa-external-link-alt" aria-hidden="true"></i>
		                </a>
		            </li>
		        </ul>
		    </div>
		    
		    <div *ngIf='pdf.isSinglePageMode()' [ngClass]="{'btn-group': !isMobile, 'pager-group': !isMobile, 'mobile-pager-group': isMobile}" role="group">
			    <button class="btn btn-default btn-sm navbar-btn" (click)="prevPdfPage()" [ngClass]="{'disabled' : pdf.currentPage<=1}" title="{{LOCALIZATION.previous}} {{LOCALIZATION.page}}">
			      <i class="fa fa-angle-double-left"></i><span class="hidden-md hidden-sm hidden-xs">{{LOCALIZATION.previous}}</span>
			    </button>
			    <button *ngIf='pdf.isSinglePageMode() && package.pages.length>0' class="btn btn-default btn-sm navbar-btn" (click)="nextPdfPage()" [ngClass]="{'disabled' : pdf.currentPage === package.pages[selectedPage].productPageMetadata.pages}" title="{{LOCALIZATION.next}} {{LOCALIZATION.page}}">
			      <span class="hidden-md hidden-sm hidden-xs">{{LOCALIZATION.next}}</span><i class="fa fa-angle-double-right"></i>
			    </button>
			    <button *ngIf='pdf.isSinglePageMode() && package.pages.length === 0' class="btn btn-default btn-sm navbar-btn" (click)="nextPdfPage()" [ngClass]="{'disabled' : pdf.currentPage === documentData['pages']}" title="{{LOCALIZATION.next}} {{LOCALIZATION.page}}">
			      <span class="hidden-md hidden-sm hidden-xs">{{LOCALIZATION.next}}</span><i class="fa fa-angle-double-right"></i>
			    </button>
		        <em *ngIf='pdf.isSinglePageMode() && package.pages.length>0' class="navbar-text">
		            {{ LOCALIZATION.pageXofN | formatString: pdf.currentPage: package.pages[selectedPage].productPageMetadata.pages }}
		        </em>
		        <em *ngIf='pdf.isSinglePageMode() && package.pages.length === 0' class="navbar-text">
		        	{{ LOCALIZATION.pageXofN | formatString: pdf.currentPage : documentData['pages'] }}
		        </em>		        
		    </div>
		    
		    <div *ngIf="documentData['searchHitData'].hasHit" class="hidden-xs" [ngClass]="{'btn-group': !isMobile, 'pager-group': !isMobile, 'mobile-pager-group': isMobile}" role="group">
			    <button class="btn btn-default btn-sm navbar-btn" (click)="prevPdfHit()" [ngClass]="{'disabled' : !hasPrevPdfHit()}" title="{{LOCALIZATION.previousHighlight}}">
			      <i class="fa fa-angle-double-left"></i><span class="hidden-md hidden-sm hidden-xs">{{LOCALIZATION.previous}}</span>
			    </button>
			    <button class="btn btn-default btn-sm navbar-btn" (click)="nextPdfHit()" [ngClass]="{'disabled' : !hasNextPdfHit()}" title="{{LOCALIZATION.nextHighlight}}">
			      <span class="hidden-md hidden-sm hidden-xs">{{LOCALIZATION.next}}</span><i class="fa fa-angle-double-right"></i>
			    </button>			    
		        <em class="navbar-text hidden-xs">
		        	{{ LOCALIZATION.XofNHighlights| formatString: ((pdf.currentHighlightIdx ?? 0) + 1): pdf.viewerAnnotations.length }}
		        </em>
		    </div>
	  </div>
	</div>
	
	<!-- Content -->
    <!-- Height is calculated by subtracting the navbar height -->
	<div class="pdfViewerFocus" style="width:100%; height:calc(100% - 52px); margin-top:0;">
	
		<iframe #pdfIframe
			 [hidden]="viewerURL == null"
			 id='pdfFullViewer' 
			 [src]="viewerURL" 
			 width="100%" height="100%" 
			 sandbox="allow-top-navigation-by-user-activation allow-scripts allow-popups allow-same-origin" 
			 (load)="pdf_viewer_onload($event)">
		</iframe> 
	
	</div>
</div>
